<template>
  <v-alert
    data-testid="insights-info-panel-widget"
    class="info-panel"
    colored-border
    :dismissible="dismissible"
  >
    <template v-slot:default>
      <div class="d-flex">
        <span
          data-testid="insights-info-panel-icon"
          class="material-icons me-2 info-panel-icon"
        >
          {{ materialIcon }}
        </span>
        <div
          data-testid="insights-info-panel-content"
          v-html="textContent"
        ></div>
      </div>
    </template>
    <template v-slot:append>
      <ActionsButton
        data-testid="insights-info-panel-action"
        class="ms-3"
        :data="action"
      />
    </template>
  </v-alert>
</template>

<script>
import ActionsButton from '@/containers/ReportsView/Widgets/ActionsButton.vue'
export default {
  name: 'InfoPanel',

  components: {
    ActionsButton,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    textContent() {
      const text = this.data?.text ?? ''
      return this.$sanitize(text)
    },

    materialIcon() {
      let dataIcon = this.data?.icon ?? 'info'
      if (dataIcon === 'info') dataIcon = dataIcon + '_outline'
      return dataIcon
    },

    dismissible() {
      return this.data?.dismissible ?? false
    },

    action() {
      return this.data?.action ?? {}
    },
  },
}
</script>

<style lang="scss" scoped>
.info-panel {
  border: solid 1px $color-blue !important;
  border-radius: 4px;
  background-color: $color-blue-grey-lighten3;

  &-icon {
    color: $color-blue;
  }
}
</style>
